export const timeFormatKeys = {
  HOURS_12: 12,
  HOURS_24: 24,
};

export const dayPeriodKeys = {
  AM: 'am',
  PM: 'pm',
};
